import { Component } from '@angular/core';

@Component({
  selector: 'app-effective-date-info',
  templateUrl: './effective-date-info.component.html',
  styleUrls: ['./effective-date-info.component.scss']
})
export class EffectiveDateInfoComponent {

}
